<template>
  <div class="twitter margin-between-section">
    <div class="row not-margin">
      <div class="col-lg-6 col-md-12 container-info">
        <div class="info">
          <img class="img-tw" src="../assets/images/twitter.png">
          <h1>{{ $t('home.twitter') }}</h1>
        </div>
      </div>
      <div ref="tsg" class="col-lg-6 col-md-12 not-padding">
        <a class="twitter-timeline" href="https://twitter.com/pragmaticscout?ref_src=twsrc%5Etfw">Tweets by pragmaticscout</a>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'twitter',
  components: {
  },
  mounted() {
    const recaptchaScript = document.createElement('script')
    const a = this.$refs.tsg
    recaptchaScript.setAttribute('src', 'https://platform.twitter.com/widgets.js')
    a.appendChild(recaptchaScript)
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.twitter{
  height: 600px;
  position: relative;
  overflow-x: hidden;
  overflow-y: scroll;
}

.opacity{
  opacity: 0;
}

.info{
  position: sticky;
  top: 0;
  text-align: left;
}

.info h1{
  font-size: 25px;
  font-family: 'plain regular', arial
}

.info p{
  padding-top: 5%;
  font-size: 18px;
}

.not-margin{
  margin: 0;
}
.not-padding{
  padding: 0;
}

.img-tw{
  width: 48px;
  margin-bottom: 20px;
}


/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {}

/* Larger than desktop */
@media (max-width: 992px) {

  .twitter{
    border-top: 1px solid #000;
    padding-top: 10%;
    margin-top: 10%;
  }  
  
  .twitter-tweet .twitter-tweet-rendered{
    margin: 20px auto !important;
  }

  .not-padding{
    padding: 15px;
  }

  .info-form-contact h1{
    font-size: 16px;
    margin-top: 15px;
  }
}

/* Larger than tablet */
@media (max-width: 768px) {

  .twitter{
    border-top: 1px solid #000;
    padding-top: 10%;
    margin-top: 10%;
  }  
  .not-padding{
    padding: 15px;
  }

  .info-form-contact h1{
    font-size: 15px;
    margin-top: 15px;
  }

}

/* Larger than phablet */
@media (max-width: 550px) {
  .info-form-contact h1{
    font-size: 14px;
  }

  .img-about{
    display: none;
  }
  .con-i input{
    width: 71%;
  }
}

/* Larger than mobile */
@media (max-width: 400px) {}



</style>
